import { toast } from 'react-toastify'
import formatDistance from 'date-fns/formatDistance'

export function getDateAgo(date: string) {
  return date
    ? formatDistance(new Date(date), new Date(), { addSuffix: true })
    : ''
}

export function getRandomKey() {
  return `_${Math.random().toString(36).substr(2, 9)}`
}

export function getToastOptions(options?: any) {
  return {
    position: toast.POSITION.BOTTOM_RIGHT,
    ...options,
  }
}

export const toastSuccess = (msg: string, options?: object[]) => {
  return toast.success(msg, getToastOptions(options))
}

export const toastError = (msg: string, options?: object[]) => {
  return toast.error(msg, getToastOptions(options))
}

export const toastInfo = (msg: string, options?: object[]) => {
  return toast.info(msg, getToastOptions(options))
}

export const toastWarning = (msg: string, options?: object[]) => {
  return toast.warn(msg, getToastOptions(options))
}
